/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { Product } from '../../../core/_models'
import { formatMonetaryToBr } from '../../../../../utils/formatMonetaryToBr'

type Props = {

    product: Product
}

const PackagePriceCell: FC<Props> = ({ product }) => (
    <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 text-hover-danger mb-1'>
            {product.packagePrice ? formatMonetaryToBr(product.packagePrice.toString()) : 'N/A'}
        </a>
    </div>
)

export { PackagePriceCell }
